import { Component, OnInit, NgZone, ChangeDetectorRef } from '@angular/core';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { ModalService } from 'src/modules/base/services/modal.service';
import { ModalSize } from 'src/modules/base/services/smart-modal.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { DialogConfig } from '../../dialog/dialog-config';

@Component({
    selector: 'app-manage-filter',
    templateUrl: './manage-filter.component.html',
    styleUrls: ['./manage-filter.component.scss'],
    standalone: false
})
export class ManageFilterComponent implements OnInit {
  public config: any = {};
  public data: any = {};
  d1: any;
  d2: any;
  d3: any;
  constructor(
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private dialogConfig: DialogConfig,
    private modalService: ModalService,
    public rolePermissionService?: RolePermissionService,
    public alerts?: AlertsService
  ) {

  }

  dragStartListner(event) {
    var target = event.target;
    let targetE = <HTMLElement>(<HTMLElement>target);
    this.config.dragged = target;
    this.config.id = targetE.id;
    this.config.list = targetE.parentNode.children;
    for (let i = 0; i < this.config.list.length; i += 1) {
      if (this.config.list[i] === this.config.dragged) {
        this.config.index = i;
      }
    }
    console.log(targetE);
  }

  dropListner(event) {
    var target = event.target;
    let targetE = <HTMLElement>(<HTMLElement>target);
    if (targetE.className.includes('dropzone') && targetE.id !== this.config.id) {
      for (let i = 0; i < this.config.list.length; i += 1) {
        if (this.config.list[i] === target) {
          this.config.indexDrop = i;
        }
      }
      if(this.data.data[this.config.index]["userGroupId"] == undefined && this.data.data[this.config.indexDrop]["userGroupId"] == undefined){
        this.saveChanged(this.config.index, this.config.indexDrop);
      }else{
        this.alerts.info("fsucf");
        this.cdr.detectChanges();
      }
      
    }
  }
  dropOverListner(target) {
    event.preventDefault();
  }

  saveChanged(prevIndex, curIndex) {
    var currentData = this.data.data[prevIndex];
    this.data.data[prevIndex] = this.data.data[curIndex];
    this.data.data[curIndex] = currentData;
    this.saveFilter(this.data.data);
  }
  removeFilter(item, index) {
    const dialogRef = this.modalService.confirm('DELETE', 'Are you sure you want to delete ' + item.name + '?', ModalSize.Sm);
    dialogRef.subscribe(result => {
      if (result) {
        if (item.userGroupId != undefined && item.userGroupId ? !this.rolePermissionService.checkAccessPermission('user_group_filter', 'user_group_filter', 'account-management') : false) {
          this.alerts.info("Not allowed to delete");
        }
        else {
          if (this.data != undefined && this.data.data != undefined && this.data.data[index] != undefined && this.data.data[index].userGroupId != undefined && this.data.data[index].key != undefined) {
           
            
              this.data.self.saveTableConfigData({filter__:[]}, () => {
                this.data.self.getTableConfig((saveData) => {
                  saveData["filter__"] = this.data.data;
                  this.data.data.splice(index, 1);
                  this.cdr.detectChanges();
                },true);//forcing it to get the latest data
              }, true,this.data.data[index].key);
          }
          else {

            this.data.data.splice(index, 1);
            this.data.self.getTableConfig((saveData) => {
              saveData["filter__"] = this.data.data;
              if (saveData["filter__"] != undefined && saveData["filter__"].length != undefined) {
                saveData["filter__"] = saveData["filter__"].filter(obj => !obj.userGroupId);
              }
              this.cdr.detectChanges();
              this.data.self.saveTableConfigData(saveData, () => {
                this.data.self.getTableConfig((saveData) => {
                  saveData["filter__"] = this.data.data;
                  this.cdr.detectChanges();
                });
              });
            });
          }
        }


      }
    },
      () => { });
    // this.saveFilter(this.data.data);
  }
  saveFilter(data) {
    if (data.length) {
      data = data.filter(x => x.userGroupId == undefined);//only save user specific data and filter account filter data
      this.data.self.getTableConfig((saveData) => {
        saveData["filter__"] = data;
        this.cdr.detectChanges();
        this.data.self.saveTableConfigData(saveData, () => {

        });
      });
    }
  }
  ngOnInit() {
    this.data = this.dialogConfig.data;
    let arr = [];
    this.data.data.forEach(element => {
      if (element['type'] == undefined) {
        arr.push(element);
      }
    });
    this.data.data = arr;
    console.log("data Manage filter ", this.data);
    this.d1 = (event) => this.dragStartListner(event);
    this.d2 = (event) => this.dropOverListner(event);
    this.d3 = (event) => this.dropListner(event);
    this.ngZone.runOutsideAngular(() => {
      document.addEventListener("dragstart", this.d1, false);
      document.addEventListener("dragover", this.d2, false);
      document.addEventListener("drop", this.d3, false);
    })
    console.log(this);
  }

  ngOnDestroy() {
    document.removeEventListener("dragstart", this.d1, false);
    document.removeEventListener("dragover", this.d2, false);
    document.removeEventListener("drop", this.d3, false);
  }


}
